import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ShowMessageBaseService {
  private readonly errorCloseTimeout = 5000;
  private readonly messageService: MessageService = inject(MessageService);

  showMessageInfo(text: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Info',
      detail: text,
    });
  }

  defaultErrorMessage(summary: string, error: string): void {
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: error,
      life: this.errorCloseTimeout,
      closable: true,
    });
  }
}
